import { FlexContainer as FlexContainer_ } from '@taxdown/piccolo-web';
import styled, { css } from 'styled-components';
import { CustomerType } from 'Types/common';

export const SpinnerFlexContainer = styled(FlexContainer_)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme: { system } }) => system.zIndex.fds_sys_zindex_default};
`;

export const FlexContainer = styled(FlexContainer_)<{ $subscription: CustomerType }>`
  position: relative;
  max-width: 310px;
  ${({ $subscription }) =>
    !$subscription &&
    css`
      width: 100%;
      padding: ${({ theme: { reference } }) => reference.dimension_16};
    `}
`;
